import { Layout } from './components/Layout/Layout';
import { ListItem } from './components/ListItem/ListItem';
import { ScrollableList } from './components/ScrollableList/ScrollableList';

/** Mirrors `Page` / `Card`: named subcomponents on one export. */
interface SelectableListStepComposition {
	Layout: typeof Layout;
	ScrollableList: typeof ScrollableList;
	ListItem: typeof ListItem;
}

export const SelectableListStep: SelectableListStepComposition = {
	Layout,
	ScrollableList,
	ListItem,
};

export type { SelectableListStepLayoutProps } from './components/Layout/Layout';
export type { SelectableListStepListItemProps } from './components/ListItem/ListItem';
export type { SelectableListStepScrollableListProps } from './components/ScrollableList/ScrollableList';
